<!--
일괄기능-컨트롤러
------------------------------------

-->
<template>
    <div
        class="uk-card uk-card-default uk-card-small"
        v-show="hideNoneChecked === false || itemChecked"
        :uk-sticky="onSticky && itemChecked"
    >
        <div class="header uk-card-header uk-flex uk-flex-between uk-flex-bottom">

            <!-- 선택개수안내 -->
            <div class="selected-msg" v-show="itemChecked">
                <span v-html="itemCheckedInfo"></span>
                <span v-for="rc in checkedRegionCounts" class="region-count-badge">
                    <img v-if="rc.flag16" :src="rc.flag16" class="region-count-flag" />{{ rc.name }} <span class="region-count-num">{{ rc.count }}</span>
                </span>
            </div>

            <!-- 선택된 아이템 없음 -->
            <div class="no-selected-msg" v-show="! itemChecked">
                {{ batch.item_checked_nothing_msg }}
            </div>

            <!-- 선택 추가정보 영역 -->
            <slot name="selected-additional"></slot>
        </div>

        <div class="uk-card-body">
            <!-- 작업 영역 -->
            <slot name="jobs"></slot>
        </div>


    </div>
</template>

<script>
    import checkedCountable from './checked-countable';
    import stickiable from './stickable';

    export default {
        mixins: [
            checkedCountable,
            stickiable,
        ],
        props: {

        },
        data: function () {
            return {
            };
        },
        computed: {
        },
        methods: {

        },
    }
</script>

<style lang="scss" scoped>

    // 선택 / 미선택시, 높이값이 변하지 않고 고정되도록 함.
    .header {
        height: 2rem;
    }

    .region-count-badge {
        display: inline-flex;
        align-items: center;
        background: #f0f4f8;
        border-radius: 3px;
        padding: 1px 6px;
        margin-left: 4px;
        font-size: 12px;
    }

    .region-count-flag {
        width: 14px;
        height: 14px;
        vertical-align: middle;
        margin-right: 2px;
    }

    .region-count-num {
        color: #1e87f0;
        font-weight: bold;
        margin-left: 3px;
    }
</style>